import {
  faCalendarCheck as falCalendarCheck,
  faCalendarHeart as falCalendarHeart,
  faCopy as falCopy,
  faGlobe as falGlobe,
  faTriangleExclamation as falTriangleExclamation,
} from '@fortawesome/pro-light-svg-icons'
import {
  faArrowDown as farArrowDown,
  faArrowLeft as farArrowLeft,
  faArrowRight as farArrowRight,
  faArrowUp as farArrowUp,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faBadgeCheck as farBadgeCheck,
  faBadgePercent as farBadgePercent,
  faChevronRight as farChevronRight,
  faCircleUser as farCircleUser,
  faCopy as farCopy,
  faEyeSlash as farEyeSlash,
  faFamilyPants as farFamilyPants,
  faGiftCard as farGiftCard,
  faHouse as farHouse,
  faHouseLock as farHouseLock,
  faInfoCircle as farInfoCircle,
  faLayerGroup as farLayerGroup,
  faMoonStars as farMoonStars,
  faPaw as farPaw,
  faPencil as farPencil,
  faSearch as farSearch,
  faUtensils as farUtensils,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faArrowLeft as fasArrowLeft,
  faBadgeCheck as fasBadgeCheck,
  faBadgePercent as fasBadgePercent,
  faCalendarHeart as fasCalendarHeart,
  faChevronRight as fasChevronRight,
  faGiftCard as fasGiftCard,
  faHouse as fasHouse,
  faLocationArrow as fasLocationArrow,
  faUser as fasUser,
  faUtensils as fasUtensils,
  faXmark as farXmark,
} from '@fortawesome/pro-solid-svg-icons'
import { faSquare as faslSquare } from '@fortawesome/sharp-light-svg-icons'
import {
  faChevronDown as fassChevronDown,
  faMinus as fassMinus,
  faPlus as fassPlus,
  faSquare as fassSquare,
  faSquareCheck as fassSquareCheck,
} from '@fortawesome/sharp-solid-svg-icons'

// "Supported" icons only
export const ICONS = {
  falCalendarCheck,
  falCalendarHeart,
  falCopy,
  falGlobe,
  falTriangleExclamation,
  farArrowDown,
  farArrowLeft,
  farArrowRight,
  farArrowUp,
  farArrowUpRightFromSquare,
  farBadgeCheck,
  farBadgePercent,
  farChevronRight,
  farCircleUser,
  farCopy,
  farEyeSlash,
  farFamilyPants,
  farGiftCard,
  farHouse,
  farHouseLock,
  farInfoCircle,
  farLayerGroup,
  farMoonStars,
  farPaw,
  farPencil,
  farSearch,
  farUtensils,
  farXmark,
  fasArrowLeft,
  fasBadgeCheck,
  fasBadgePercent,
  fasCalendarHeart,
  fasChevronRight,
  fasGiftCard,
  fasHouse,
  fasLocationArrow,
  fasUser,
  fasUtensils,
  faslSquare,
  fassChevronDown,
  fassMinus,
  fassPlus,
  fassSquare,
  fassSquareCheck,
}
